module.exports = __webpack_public_path__ + "static/media/undraw_quiz_nlyh.ff8d98f3.svg";